import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import menuConfigurationActions from "../../../redux/menuConfiguration/actions";
import MenuConfigurationMenuItems from "../../../components/User/MenuConfigurationComponents/MenuConfigurationMenuItems/MenuConfigurationMenuItems";
import MenuConfigurationCategories from "../../../components/User/MenuConfigurationComponents/MenuConfigurationCategories/MenuConfigurationCategories";
import MenuConfigurationTags from "../../../components/User/MenuConfigurationComponents/MenuConfigurationTags/MenuConfigurationTags";
import MenuConfigurationTabExtraContent from "../../../components/User/MenuConfigurationComponents/MenuConfigurationTabExtraContent";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import "../../../components/User/MenuConfigurationComponents/index.css";

const MenuConfigurations = () => {
  const dispatch = useDispatch();
  const [restaurantId, setRestaurantId] = useState(null);
  const organizationId = localStorage.getItem("organizationId");
  const { getAllCategories, getAllMenuItems, getAllItemsTags } =
    menuConfigurationActions;
  const { reloadCategories, reloadMenuItems, reloadTags } = useSelector(
    (state) => state.menuConfigurationReducer
  );
  const { menuConfiguration } = useSelector(
    (state) => state.organizationsReducer
  );
  const { organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const defaultRestaurantId = organizations?.find(
    (item) => item.id === Number(organizationId)
  )?.defaultTouchSaleRestaurantId;

  const defaultOrganizatoinLanguage = menuConfiguration?.defaultLanguage;

  useEffect(() => {
    setRestaurantId(defaultRestaurantId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRestaurantId]);

  useEffect(() => {
    if (
      restaurantId !== null &&
      restaurantId !== undefined &&
      defaultOrganizatoinLanguage !== undefined
    ) {
      dispatch(
        getAllMenuItems(
          organizationId,
          restaurantId,
          defaultOrganizatoinLanguage
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadMenuItems, restaurantId, defaultOrganizatoinLanguage]);

  useEffect(() => {
    dispatch(getAllCategories(organizationId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadCategories]);

  useEffect(() => {
    dispatch(getAllItemsTags(organizationId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadTags]);

  const menuConfigurationTabItems = [
    {
      key: "menu",
      label: "Продукти",
      children: (
        <MenuConfigurationMenuItems
          restaurantId={restaurantId}
          setRestaurantId={setRestaurantId}
        />
      ),
    },
    {
      key: "categories",
      label: "Групи",
      children: <MenuConfigurationCategories />,
    },
    {
      key: "tags",
      label: "Тагове",
      children: <MenuConfigurationTags />,
    },
  ];

  return (
    <>
      <PageHeader text="Меню конфигурация" />
      <Tabs
        animated
        className="menu-configuration-tabs"
        items={menuConfigurationTabItems}
        type="card"
        tabBarExtraContent={
          <div className="menu-configuration-tab-extra-container-mobile-display-none">
            <MenuConfigurationTabExtraContent
              restaurantId={restaurantId}
              setRestaurantId={setRestaurantId}
            />
          </div>
        }
      />
    </>
  );
};

export default MenuConfigurations;
